import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export function ProductImageGallery({ images, activeImg, imgTransition, switchImage, prevImage, nextImage, productName }) {
  return (
    <div className="flex flex-col gap-4">
      {/* Main Image */}
      <div className="relative aspect-[4/5] bg-[#F9F9F9] overflow-hidden">
        <img
          src={images[activeImg]}
          alt={`${productName} — view ${activeImg + 1}`}
          className={`object-cover w-full h-full transition-opacity duration-200 ${imgTransition ? 'opacity-0' : 'opacity-100'}`}
          data-testid="product-image"
        />
        {images.length > 1 && (
          <>
            <button
              onClick={prevImage}
              className="absolute left-3 top-1/2 -translate-y-1/2 w-9 h-9 bg-white/80 backdrop-blur-sm border border-[#E5E5E5] flex items-center justify-center transition-opacity hover:bg-[#D4AF37] hover:border-[#D4AF37] hover:text-white"
              data-testid="prev-image-btn"
              aria-label="Previous image"
            >
              <ChevronLeft size={16} />
            </button>
            <button
              onClick={nextImage}
              className="absolute right-3 top-1/2 -translate-y-1/2 w-9 h-9 bg-white/80 backdrop-blur-sm border border-[#E5E5E5] flex items-center justify-center transition-opacity hover:bg-[#D4AF37] hover:border-[#D4AF37] hover:text-white"
              data-testid="next-image-btn"
              aria-label="Next image"
            >
              <ChevronRight size={16} />
            </button>
            <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5">
              {images.map((_, idx) => (
                <button
                  key={`dot-${idx}`}
                  onClick={(e) => { e.stopPropagation(); switchImage(idx); }}
                  className={`w-1.5 h-1.5 rounded-full transition-all ${idx === activeImg ? 'bg-[#D4AF37] w-4' : 'bg-white/70'}`}
                  data-testid={`dot-${idx}`}
                  aria-label={`Image ${idx + 1}`}
                />
              ))}
            </div>
          </>
        )}
      </div>

      {/* Thumbnail Strip */}
      {images.length > 1 && (
        <div className="flex gap-2" data-testid="thumbnail-strip">
          {images.map((src, idx) => (
            <button
              key={`thumb-${idx}`}
              onClick={() => switchImage(idx)}
              className={`relative flex-1 aspect-square bg-[#F9F9F9] overflow-hidden border-2 transition-all duration-150 ${idx === activeImg ? 'border-[#D4AF37]' : 'border-transparent hover:border-[#D4AF37]/40'}`}
              data-testid={`thumbnail-${idx}`}
              aria-label={`View image ${idx + 1}`}
            >
              <img src={src} alt={`${productName} thumbnail ${idx + 1}`} className="object-cover w-full h-full" />
              {idx === activeImg && <div className="absolute inset-0 bg-[#D4AF37]/10" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
